import { Dialog, Toast } from "antd-mobile";
import axios from "axios";
import React, { useState, useContext, useEffect } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  Row,
  FormLabel,
  FormControl,
} from "react-bootstrap";
import { Divider, Space, Tag, Avatar, Spin } from "antd";
import PsContext from "../../context";
import { jsonToQuery } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import { Image, List } from "antd-mobile";
import { FloatButton } from "antd";
import { Tabs } from "antd";
import $ from "jquery";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";
import AddService from "./addService";

import ViewService from "./viewService";
const ListServiceRequests = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [action, setAction] = useState("list");
  const [viewData, setViewData] = useState(null);

  const getRandomLightColor = () => {
    var hue = Math.floor(Math.random() * 360); // generate a random hue value between 0 and 360
    var saturation = Math.floor(Math.random() * 50) + 50; // generate a random saturation value between 50 and 100
    var lightness = Math.floor(Math.random() * 30) + 70; // generate a random lightness value between 70 and 100
    var color = "hsl(" + hue + ", " + saturation + "%, " + lightness + "%)"; // combine the hue, saturation, and lightness values into an HSL color string
    return color;
  };

  const getReport = () => {
    setLoader(true);
    setDataList([]);

    const form = new FormData();

    form.append("request_type", props.requestType.id);
    axios
      .post(
        ServiceUrl.REQUEST.LIST_REQUEST + "?student_uuid=" + context.user.uuid,
        form
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }
        setLoader(false);
      });
  };
  useEffect(() => {
    getReport();
  }, []);
  const isOnlinePayment = () => {
    var payModes = props.requestType.payment_modes.split(",");
    if (payModes.includes("online")) return true;
    else return false;
  };
  return (
    <>
      <Spin spinning={loader}>
        {action === "list" && (
          <>
            <Header
              title={"Request : " + props.requestType.request_type_name}
              backAction={true}
              rightActions={[]}
            />
            <FloatButton
              type="primary"
              shape="circle"
              onClick={() => setAction("add")}
              icon={<PlusOutlined />}
              style={{
                right: 50,
              }}
            />
            <br />
            <div className="page-content-wrapper">
              <div className="container">
                <Card className="mb-2">
                  <Card.Body className="fs-6">
                    <List>
                      {dataList.map((item) => (
                        <List.Item
                          key={item.request_status}
                          prefix={
                            <Avatar
                              style={{
                                backgroundColor: getRandomLightColor(),
                                verticalAlign: "middle",
                                textTransform: "uppercase",
                              }}
                              size="large"
                            >
                              {item.description.charAt(0)}
                            </Avatar>
                          }
                          onClick={(e) => {
                            setViewData(item);
                            setAction("view");
                          }}
                        >
                          <Space>
                            <Tag color="green">{item.request_status}</Tag>

                            {isOnlinePayment() &&
                              (item.pay_status === "paid" ||
                                item.pay_status === "shipped") && (
                                <Tag color="green">Paid</Tag>
                              )}
                            {isOnlinePayment() &&
                              item.pay_status !== "paid" &&
                              item.pay_status !== "shipped" && (
                                <Tag color="red">Unpaid</Tag>
                              )}
                          </Space>
                          <br />
                          {item.description.substring(0, 50)}
                        </List.Item>
                      ))}
                    </List>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </>
        )}
        {action == "add" && (
          <>
            <Header
              title={"Request : " + props.requestType.request_type_name}
              backAction={true}
              rightActions={
                <li>
                  <i
                    className="fa-solid fa-close fs-6"
                    onClick={(e) => setAction("list")}
                  ></i>
                </li>
              }
            />

            <br />
            <AddService
              requestType={props.requestType}
              onSuccess={() => {
                getReport();
                setAction("list");
              }}
            />
          </>
        )}
        {action === "view" && (
          <>
            <Header
              title={"Request : " + props.requestType.request_type_name}
              backAction={true}
              rightActions={
                <li>
                  <i
                    className="fa-solid fa-close fs-6"
                    onClick={(e) => setAction("list")}
                  ></i>
                </li>
              }
            />
            <br />
            <ViewService
              requestType={props.requestType}
              requestItem={viewData}
              onClose={() => setAction("list")}
              onReloadClose={() => {
                getReport();
                setAction("list");
              }}
              onSuccess={() => {
                getReport();
                setAction("list");
              }}
            />
          </>
        )}
      </Spin>
    </>
  );
};
export default ListServiceRequests;
